import { handleActions } from "redux-actions";
import { IResponse } from "middleware/api";

import {
    CONTACT_GROUP_RECIPIENTS_FETCH_FAILURE,
    CONTACT_GROUP_RECIPIENTS_FETCH_START,
    CONTACT_GROUP_RECIPIENTS_FETCH_SUCCESS,
    CONTACT_GROUP_RECIPIENTS_FILTER_CHANGE,
    CONTACT_GROUP_RECIPIENTS_RESET,
    CONTACT_GROUP_RECIPIENTS_SEARCH_CHANGE,
    CONTACT_GROUP_RECIPIENTS_SORT_CHANGE,
    CONTACT_GROUP_TAB_CHANGE,
} from "constants/action-types";

export interface IState {
    error?: Error;
    isFetching: boolean;
    nextPage: string;
    result: any;
    search: string;
    sort: string;
    sortOrder: string;
}

export const initialState: IState = {
    error: undefined,
    isFetching: false,
    nextPage: undefined,
    result: [],
    search: "",
    sort: "__name",
    sortOrder: "asc",
};

export const contactGroupRecipientsReducer = handleActions<IState, any>(
    {
        [CONTACT_GROUP_RECIPIENTS_FETCH_START]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
            };
        },
        [CONTACT_GROUP_RECIPIENTS_FETCH_SUCCESS]: (state: IState, { payload, meta = {}, error }: IResponse): IState => {
            let result;
            if (error) {
                result = state.result;
            } else {
                result = meta.replace ? payload : state.result.concat(payload);
            }

            return {
                ...state,
                error: error ? payload : undefined,
                isFetching: false,
                nextPage: meta && meta.next ? meta.next : undefined,
                result,
            };
        },
        [CONTACT_GROUP_RECIPIENTS_FETCH_FAILURE]: (state: IState, { error }: IResponse): IState => {
            return {
                ...state,
                error,
                isFetching: false,
            };
        },
        [CONTACT_GROUP_RECIPIENTS_SORT_CHANGE]: (state: IState, { payload }: IResponse): IState => {
            return {
                ...state,
                isFetching: false,
                result: [],
                sort: payload.sort,
                sortOrder: payload.sortOrder,
            };
        },
        [CONTACT_GROUP_RECIPIENTS_RESET]: (): IState => {
            return initialState;
        },
        [CONTACT_GROUP_RECIPIENTS_SEARCH_CHANGE]: (state: IState, { payload }: IResponse): IState => {
            return {
                ...state,
                result: [],
                search: payload,
            };
        },
        [CONTACT_GROUP_RECIPIENTS_FILTER_CHANGE]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
                result: [],
            };
        },
        [CONTACT_GROUP_TAB_CHANGE]: (state: IState): IState => {
            return {
                ...state,
                nextPage: undefined,
                result: [],
            };
        },
    } as any,
    initialState,
);
